var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuthenticationService } from '../../service/authentication.service';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { BaseComponent } from '../base/base.component';
import { MenuService } from '../menu/menu.service';
import { UnitService } from '../../service/unit.service';
import { User } from '../../models/user/user';
import { LanguageService } from '../language/language.service';
import { ConfigService } from '../../service/config.service';
var HeaderComponent = /** @class */ (function (_super) {
    __extends(HeaderComponent, _super);
    function HeaderComponent(router, route, logger, message, page, authenticationService, uservice, menuService, langService, config) {
        var _this = _super.call(this, router, route, logger, message, page, authenticationService) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.message = message;
        _this.page = page;
        _this.authenticationService = authenticationService;
        _this.uservice = uservice;
        _this.menuService = menuService;
        _this.langService = langService;
        _this.config = config;
        _this.navBtn = true;
        _this.unit = true;
        // private user: { [key: string]: string } = {};
        _this.open = false;
        _this.logo = _this.config.config['header_logo'] || '';
        _this.userSubscription = _this.uservice.get().subscribe(function (user) {
            if (User.isUser(user)) {
                _this.currentUser = user;
            }
        });
        _this.langSubscription = _this.langService.get().subscribe(function (lang) {
            if (lang) {
                _this.lang = lang;
            }
        });
        return _this;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        // this.user = JSOG.parse(localStorage.getItem("currentUser"));
        var open = this.menuService.getMenuOpenState('menu-showLeftPush');
        this.open = (typeof open === 'undefined') ? true : open;
    };
    HeaderComponent.prototype.logout = function () {
        var _this = this;
        this.authenticationService.logout().subscribe(function (data) {
            _this.router.navigate(['/login']);
        }, function (error) {
            _this.logger.error(error);
        });
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.userSubscription.unsubscribe();
        this.langSubscription.unsubscribe();
    };
    HeaderComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'pa-header',
                    template: "<header class=\"header\">\n  <p>\n    <button *ngIf=\"navBtn\" id=\"showLeftPush\" class=\"navBtn\" [class.active]=\"open\">\u2261</button>\n  </p>\n  <p class=\"siteId\">\n    <a [routerLink]=\"'/top'\"><img [src]=\"logo\" alt=\"\" width=\"160\"></a>\n  </p>\n  <ul class=\"hNav\">\n    <li [class.hNav_li]=\"unit\">\n      <currentunit [unit]=\"unit\"></currentunit>\n    </li>\n    <li class=\"hNav_li hNav_li-role\">{{ currentUser?.roles }}</li>\n    <li class=\"hNav_li hNav_accountMenu\">\n      <a class=\"hNav_accountMenuAnchor\" href=\"javascript:void(0);\">\n        <span class=\"hNav_accountMenuAnchor_name\">{{ currentUser?.sei }}&nbsp;{{ currentUser?.mei }}</span>\n        <img class=\"hNav_accountMenuFlag\" src=\"{{ lang?.img }}\" alt=\"\">\n      </a>\n      <ul class=\"hNav_accountMenuUl\">\n        <li class=\"hNav_accountMenuLi hNav_accountMenuLi-sp\">\n          <ul>\n            <li *ngFor=\"let role of currentUser?.roles\">{{ role }}</li>\n            <li>{{ currentUser?.sei }}&nbsp;{{ currentUser?.mei }}</li>\n          </ul>\n        </li>\n        <li class=\"hNav_accountMenuLi\">\n          <language></language>\n        </li>\n        <li class=\"hNav_accountMenuLi\">\n          <a [routerLink]=\"'/password'\">{{ (msg | async)['AuComponent.passwordChange.link'] }}</a>\n        </li>\n        <li class=\"hNav_accountMenuLi\">\n          <a href=\"javascript:void(0);\" (click)=\"logout()\">{{ (msg | async)['AuComponent.logout.link'] }}</a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</header>\n"
                }] }
    ];
    /** @nocollapse */
    HeaderComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: MessageService },
        { type: PageService },
        { type: AuthenticationService },
        { type: UnitService },
        { type: MenuService },
        { type: LanguageService },
        { type: ConfigService }
    ]; };
    HeaderComponent.propDecorators = {
        navBtn: [{ type: Input }],
        unit: [{ type: Input }]
    };
    return HeaderComponent;
}(BaseComponent));
export { HeaderComponent };
//# sourceMappingURL=header.component.js.map